import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Feature, Layer, MeasureLengthUnit, SpatialFilterQueryType, SpatialFilterType } from '@igo2/geo';
import { OutilXYService } from '../../../shared/services/outilXY.service';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { EntityStore } from '@igo2/common/entity';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { SigtSpatialFilterListComponent } from '../sigt-spatial-filter-list/sigt-spatial-filter-list.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-sigt-spatial-filter-type',
    templateUrl: './sigt-spatial-filter-type.component.html',
    styleUrls: ['./sigt-spatial-filter-type.component.scss'],
    imports: [
        MatTabsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonToggleModule,
        CommonModule,
        TranslateModule,
        SigtSpatialFilterListComponent
    ]
})
export class SigtSpatialFilterTypeComponent implements OnInit, OnDestroy {
  @Input() store: EntityStore<Feature>;

  public queryType: string[] = [
    'Arrond',
    'CircFed',
    'CircProv',
    //'DirReg', Nous remplaçons ça avec un service du MRNF
    'DirectionRegionalMRNF',
    'Mun',
    'MRC',
    'AdmRegion',
    'RegTour'
  ];

  @Input() selectedTabIndex = 0;


  /**
   * Reference to the SpatialFIlterType enum
   * @internal
   */
  public spatialType = SpatialFilterType;

  @Input() activeDrawType: SpatialFilterType = this.spatialType.Polygon;

  @Input() selectedQueryType: SpatialFilterQueryType;

  @Input() zone: Feature;

  @Input() layers: Layer[] = [];

  public type: SpatialFilterType;

  @Output() eventType = new EventEmitter<SpatialFilterType>();

  @Output() eventQueryType = new EventEmitter<SpatialFilterQueryType>();

  @Output() zoneChange = new EventEmitter<Feature>();
  @Output() zoneWithBufferChange = new EventEmitter<Feature>();

  @Output() bufferChange = new EventEmitter<number>();
  @Output() measureUnitChange = new EventEmitter<MeasureLengthUnit>();

  #outilXYSubscription: Subscription;

  constructor(private outilXYService: OutilXYService) {
    this.#outilXYSubscription = this.outilXYService.requeteOutilXY$.subscribe(_ => {
      this.selectedTabIndex = 1;
      this.activeDrawType = SpatialFilterType.Point;
    });
  }

  ngOnInit() {
    if (this.selectedTabIndex === 0) {
      this.type = this.spatialType.Predefined;
    }
    if (this.selectedTabIndex === 1) {
      this.type = this.activeDrawType;
    }
    this.eventType.emit(this.type);
  }

  ngOnDestroy(): void {
    if (this.#outilXYSubscription) {
      this.#outilXYSubscription.unsubscribe();
    }
  }

  onTypeChange(event) {
    if (this.selectedTabIndex === 0) {
      this.type = SpatialFilterType.Predefined;
    }
    if (this.selectedTabIndex === 1) {
      this.type = this.activeDrawType;
    }
    this.eventType.emit(this.type);
  }

  onDrawTypeChange(spatialType: SpatialFilterType) {
    this.activeDrawType = spatialType;
    this.eventType.emit(this.activeDrawType);
  }

  onSelectionChange() {
    this.eventQueryType.emit(this.selectedQueryType);
    this.zoneChange.emit(undefined);
  }
}
